import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { LocalOffersApiService } from './local-offers-api-service';

export class LocalOffersDataSource extends ApiDataSource {
  protected Data: BehaviorSubject<[]> = new BehaviorSubject([]);
  constructor(
    protected Api: LocalOffersApiService,
    private readonly role: any,
    private listingId?: any
  ) {
    super();
  }

  protected loadData(PageEvent: PageEvent) {
    return this.Api.listWithPageEvent(this.role, this.listingId, this.filter.value, PageEvent);
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }

  public save(LocalOffer) {
    return this.Api.save(
      this.role,
      LocalOffer
    ).then((result) => {
      this.loadWithPageEvent();
      return result.data;
    });
  }

  public removeLocation(locationId) {
    return this.Api.deleteLocation('admin', locationId);
  }


  public delete(LocalOffer) {
    return this.Api.delete(this.role, LocalOffer).then(result => {
      this.loadWithPageEvent();
      return result;
    });
  }

}
